/* eslint no-var:0, vars-on-top:0, func-names:0, prefer-arrow-callback:0 */
(function iframeRenderer() {
    const FIRST_POSSIBLE_JS_EXECUTION = Date.now();
    /* global RELEASE_DIR, __webpack_hash__ */
    function createIframe(iframeId, document, callback) {
        const frame = document.createElement('iframe');
        let onloadFired = false;
        frame.onload = function iframeOnload() {
            if (!onloadFired) {
                callback(frame);
                onloadFired = true;
            }
        };
        frame.id = iframeId;
        frame.style.display = 'none';
        frame.title = 'Tidio Chat code';
        document.body.appendChild(frame);
        // because firefox
        setTimeout(function fakeOnload() {
            if (!onloadFired) {
                callback(frame);
                onloadFired = true;
            }
        }, 1000);
    }

    function injectScript(iframeNode, src) {
        const iframeWindow = iframeNode.contentWindow;
        const iframeDocument = iframeWindow.document;
        const script = iframeDocument.createElement('script');
        script.src = src;
        script.async = true;
        iframeDocument.body.appendChild(script);
    }
    // It is coming from webpack.localbuild (not available on prod conf)
    const IS_LOCAL_PROD_BUILD =
        // eslint-disable-next-line no-undef
        typeof PRODUCTION_DEVELOPMENT_BUILD === 'boolean' && PRODUCTION_DEVELOPMENT_BUILD === true;
    const WIDGET_URL = IS_LOCAL_PROD_BUILD
        ? `${process.env.NEW_WIDGET_URL_WIDGET}/dist/`
        : process.env.NEW_WIDGET_URL_WIDGET;
    function getWidgetUrl() {
        if (process.env.NODE_ENV === 'production') {
            return `${WIDGET_URL.replace(
                /\/$/,
                '',
                // eslint-disable-next-line camelcase
            )}/${RELEASE_DIR}/static/js/widget.${__webpack_hash__}.js`;
        }
        return `${process.env.NEW_WIDGET_URL_WIDGET}static/js/widget.js`;
    }
    function injectWidgetIframePreload(doc) {
        let src = `${process.env.NEW_WIDGET_URL_WIDGET}static/js/WidgetIframe.js`;
        if (process.env.NODE_ENV === 'production') {
            // eslint-disable-next-line camelcase
            src = `${WIDGET_URL}${RELEASE_DIR}/static/js/chunk-WidgetIframe-${__webpack_hash__}.js`;
        }
        const link = doc.createElement('link');
        link.rel = 'preload';
        link.as = 'script';
        link.href = src;
        doc.head.appendChild(link);
    }
    function preloadWidgetSound(doc) {
        const sounds = ['tururu.mp3', 'notification-sound.mp3'];

        sounds.forEach((soundFile) => {
            const link = doc.createElement('audio');
            link.preload = 'metadata';
            link.src = `${WIDGET_URL}/${soundFile}`;
            doc.head.appendChild(link);
        });
    }
    function preconnectWebsockets(doc) {
        const src = process.env.NEW_WIDGET_URL_SOCKET;
        const link = doc.createElement('link');
        link.rel = 'preconnect';
        link.href = src;
        doc.head.appendChild(link);
    }
    function preloadFonts(doc, url) {
        try {
            const preload = doc.createElement('link');
            preload.rel = 'preload';
            preload.href = url;
            preload.as = 'font';
            preload.type = 'font/woff2';
            preload.crossOrigin = '';
            doc.head.appendChild(preload);
        } catch {
            // ignore preload errors
        }
    }

    function preconnectCfForEmoji(doc) {
        const preconnect = doc.createElement('link');
        preconnect.rel = 'preconnect';
        preconnect.href = 'https://cdnjs.cloudflare.com';
        doc.head.appendChild(preconnect);
    }

    // https://github.com/jfriend00/docReady
    // prettier-ignore
    const docReady = (function docReady() {
        var readyList = [];
        var readyFired = false;
        var readyEventHandlersInstalled = false;

        function ready() {
            if (!readyFired) {
                readyFired = true;
                for (var i = 0; i < readyList.length; i+=1) {
                    readyList[i].fn.call(window, readyList[i].ctx);
                }
                readyList = [];
            }
        }

        function readyStateChange() {
            if (document.readyState === 'complete') {
                ready();
            }
        }

        return function(callback, context) {
            if (typeof callback !== 'function') {
                throw new TypeError('callback for docReady(fn) must be a function');
            }
            if (readyFired) {
                setTimeout(function() {
                    callback(context);
                }, 1);
                return false;
            }
            readyList.push({ fn: callback, ctx: context });
            if (
                document.readyState === 'complete' ||
                (!document.attachEvent && document.readyState === 'interactive')
            ) {
                setTimeout(ready, 1);
            } else if (!readyEventHandlersInstalled) {
                if (document.addEventListener) {
                    document.addEventListener('DOMContentLoaded', ready, false);
                    window.addEventListener('load', ready, false);
                } else {
                    document.attachEvent('onreadystatechange', readyStateChange);
                    window.attachEvent('onload', ready);
                }
                readyEventHandlersInstalled = true;
            }
            return true;
        };
    })();

    function injectWidgetJs(iframe) {
        injectScript(iframe, getWidgetUrl());
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.debug('run react-devtools from terminal to inspect react components');
            injectScript(iframe, '//localhost:8097');
        }
    }
    // eslint-disable-next-line global-require, @typescript-eslint/no-require-imports
    const TidioChatApi = require('./TidioChatApi').default;
    window.tidioChatApi = new TidioChatApi();
    docReady(() =>
        // eslint-disable-next-line consistent-return
        setTimeout(() => {
            var codeAlreadyExists = window.document.getElementById('tidio-chat-code');
            var isBrowserIE = /MSIE|Trident/.test(window.navigator.userAgent);
            if (codeAlreadyExists || isBrowserIE) {
                return false;
            }
            createIframe('tidio-chat-code', window.document, (iframe) => {
                if (process.env.NODE_ENV === 'development' || IS_LOCAL_PROD_BUILD) {
                    /* eslint-disable no-underscore-dangle,no-param-reassign */
                    if (window.__REDUX_DEVTOOLS_EXTENSION__) {
                        iframe.contentWindow.__REDUX_DEVTOOLS_EXTENSION__ =
                            window.__REDUX_DEVTOOLS_EXTENSION__;
                        iframe.contentWindow.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ =
                            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
                    }
                    /* eslint-enable no-underscore-dangle, no-param-reassign */
                }
                injectWidgetIframePreload(iframe.contentWindow.document);
                preloadFonts(
                    iframe.contentWindow.document,
                    `${process.env.NEW_WIDGET_URL_WIDGET}fonts/mulish_SGhgqk3wotYKNnBQ.woff2`,
                );
                preloadFonts(
                    window.document,
                    `${process.env.NEW_WIDGET_URL_WIDGET}fonts/inter_UcCo3FwrK3iLTcviYwYZ8UA3.woff2`,
                );
                preloadWidgetSound(iframe.contentWindow.document);
                preconnectWebsockets(iframe.contentWindow.document);
                preconnectCfForEmoji(iframe.contentWindow.document);
                // eslint-disable-next-line no-param-reassign
                iframe.contentWindow.tidioChatApi = window.tidioChatApi;
                // eslint-disable-next-line no-param-reassign
                iframe.contentWindow.FIRST_POSSIBLE_JS_EXECUTION = FIRST_POSSIBLE_JS_EXECUTION;
                if ('requestIdleCallback' in window) {
                    window.requestIdleCallback(
                        function () {
                            injectWidgetJs(iframe);
                        },
                        { timeout: 5000 },
                    );
                } else {
                    setTimeout(function () {
                        injectWidgetJs(iframe);
                    }, 0);
                }
            });
        }, 0),
    );
})();
